import { Component } from '@angular/core';
import {
  REFERENCE_DATA_BUCKET_LABELS,
  REFERENCE_DATA_NOTIFIER,
  REFERENCE_DATA_PERMISSIONS,
  REFERENCE_DATA_REPORT_FILENAME,
  REFERENCE_DATA_SERVICE
} from '@nucleus/reference-data-ui';
import {
  TasksenseReferenceDataNotifierAdapter,
  TasksenseReferenceDataPermissionsAdapter,
  TasksenseReferenceDataServiceAdapter
} from './reference-data.adapter';

/**
 * TaskSense thin shell over @nucleus/reference-data-ui. The heavy lifting
 * (bucket-keyed list + edit dialog) lives in the shared lib; this component
 * just registers the three tenant adapters via DI providers and renders
 * <lib-reference-data>. Mirror of goldfish's ReferenceDataComponent.
 */
@Component({
  selector: 'reference-data',
  templateUrl: './reference-data.component.html',
  styleUrl: './reference-data.component.css',
  standalone: false,
  providers: [
    { provide: REFERENCE_DATA_SERVICE,         useExisting: TasksenseReferenceDataServiceAdapter },
    { provide: REFERENCE_DATA_PERMISSIONS,     useExisting: TasksenseReferenceDataPermissionsAdapter },
    { provide: REFERENCE_DATA_NOTIFIER,        useClass:    TasksenseReferenceDataNotifierAdapter },
    { provide: REFERENCE_DATA_REPORT_FILENAME, useValue:    'tasksense' },
    { provide: REFERENCE_DATA_BUCKET_LABELS,   useValue:    { AddressType: 'Address Type' } },
  ]
})
export class ReferenceDataComponent { }
